export default {
  'ReviewsModal.reviews': 'Отзывы',
}
